import { useState, useCallback } from 'react';
const moment = require('moment');
import { DATE_FORMAT, TIME_FORMAT } from '../../../containers/WorkkardDetail/constants';
import { testId } from '../../../utils/testIds';

export function useFormSubmit(methods, fieldConfigs, derivedState, onSuccess, onError) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(
    methods.handleSubmit(
      async (values) => {
        setIsSubmitting(true);
        try {
          const payload = buildSubmitPayload(values, fieldConfigs, derivedState);
          await onSuccess(payload);
        } catch (err) {
          console.error('[FieldEngine] Submit handler threw an error:', err);
        } finally {
          setIsSubmitting(false);
        }
      },
      (errors) => {
        if (onError) onError(errors);
        // Scroll to first error field with focus
        const firstErrorKey = Object.keys(errors)[0];
        if (firstErrorKey) {
          const wrapper = document.querySelector(`[data-test="${testId('field', firstErrorKey)}"]`);
          const focusable = wrapper?.querySelector('input, select, textarea');
          if (focusable) {
            focusable.scrollIntoView({ behavior: 'smooth', block: 'center' });
            focusable.focus({ preventScroll: true });
          } else if (wrapper) {
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    ),
    [methods, fieldConfigs, derivedState, onSuccess, onError]
  );

  return { handleSubmit, isSubmitting };
}

function buildSubmitPayload(values, fieldConfigs, derivedState) {
  const payload = {};

  fieldConfigs.forEach(config => {
    const fieldState = derivedState[config.fieldKey];

    if (fieldState && !fieldState.visible) return;

    const value = values[config.fieldKey];

    if (['date', 'datetime', 'datetimetimezone', 'datewithusertimezone'].includes(config.fieldType)) {
      payload[config.fieldKey] = formatDateValue(value, config.fieldType);
    } else {
      payload[config.fieldKey] = value;
    }

    if (config.fieldType === 'datewithtimezone') {
      const tzKey = `${config.fieldKey}tz`;
      payload[tzKey] = values[tzKey];
    }
  });

  return payload;
}

function formatDateValue(value, fieldType) {
  if (!value) return '';

  const m = moment(value);
  if (!m.isValid()) return value;

  if (fieldType === 'date') {
    return m.format(DATE_FORMAT);
  }
  if (fieldType === 'datetime' || fieldType === 'datetimetimezone') {
    return m.format(TIME_FORMAT);
  }

  return value;
}
